export default {
  // App
  "appTitle": "Multi-function Stopwatch and Timer",
  "siteIntro": "Create and manage customizable timers and stopwatches with multiple visual effects and notifications",
  
  // General
  "cancel": "Cancel",
  "save": "Save",
  "start": "Start",
  "pause": "Pause",
  "stop": "Stop",
  "reset": "Reset",
  "add": "Add",
  "edit": "Edit",
  "delete": "Delete",
  "confirm": "Confirm",
  "close": "Close",
  "back": "Back",
  "submit": "Submit",
  "timer": "Timer",
  "optional": "Optional",
  "clickAgainToDelete": "Click again to delete",
  "fullscreen": "Fullscreen",
  "exitFullscreen": "Exit Fullscreen",
  
  // Timer modes
  "countdown": "Countdown",
  "stopwatch": "Stopwatch",
  
  // TimersContainer
  "myTimers": "My Timers",
  "addTimer": "Add Timer",
  "noTimers": "No timers yet",
  "createFirstTimer": "Create your first timer",
  
  // TimerForm
  "createTimer": "Create Timer",
  "editTimer": "Edit Timer",
  "timerName": "Timer Name",
  "timerNamePlaceholder": "Enter timer name",
  "timerMode": "Timer Mode",
  "duration": "Duration",
  "hours": "Hours",
  "minutes": "Minutes",
  "seconds": "Seconds",
  "showMilliseconds": "Show Milliseconds",
  
  // Settings
  "settings": "Settings",
  "darkMode": "Dark Mode",
  "language": "Language",
  "notificationSound": "Notification Sound",
  "enableNotifications": "Enable Notifications",
  "english": "English",
  "chinese": "中文",
  "spanish": "Español",
  "french": "Français",
  "japanese": "日本語",
  
  // Notification sounds
  "default": "Default",
  "bell": "Bell",
  "digital": "Digital",
  "chime": "Chime",
  "none": "None",
  
  // Messages
  "timerComplete": "Timer Complete!",
  
  // Effects
  "effect": "Effect",
  "effectSettings": "Effect Settings",
  "effectType": "Effect Type",
  "opacity": "Opacity",
  "speed": "Speed",
  "primaryColor": "Primary Color",
  "secondaryColor": "Secondary Color",
  "circle": "Circle",
  "wave": "Wave",
  "pulse": "Pulse",
  "particles": "Particles",
  "gradient": "Gradient",
  "ripple": "Ripple",
  
  // About page
  "about": "About",
  "aboutTitle": "About This App",
  "aboutIntroTitle": "Welcome to Multi-function Stopwatch and Timer",
  "aboutIntroText": "This web application allows you to create and manage multiple customizable timers and stopwatches. Whether you need to track workout sessions, cooking times, or productivity intervals, this tool provides a flexible and user-friendly solution.",
  
  "aboutFeaturesTitle": "Key Features",
  "aboutFeatureTimersTitle": "Timers & Stopwatches",
  "aboutFeatureTimersText": "Create both countdown timers and stopwatches. Countdown timers allow you to set hours, minutes, and seconds, while stopwatches track elapsed time from zero.",
  
  "aboutFeatureNotificationsTitle": "Notifications",
  "aboutFeatureNotificationsText": "Receive audio and visual alerts when your timers complete. Choose from various notification sounds or opt for silent operation.",
  
  "aboutFeatureEffectsTitle": "Visual Effects",
  "aboutFeatureEffectsText": "Customize your timers with different visual effects like circles, waves, pulses, particles, and gradients. Adjust opacity, speed, and colors to suit your preferences.",
  
  "aboutFeatureShortcutsTitle": "Keyboard Shortcuts",
  "aboutFeatureShortcutsText": "Control your timers efficiently with keyboard shortcuts for starting, pausing, stopping, and resetting.",
  
  "aboutFeatureLanguagesTitle": "Multi-language Support",
  "aboutFeatureLanguagesText": "Use the app in your preferred language. Currently supports English, Chinese, Spanish, French, and Japanese.",
  
  "aboutFeatureDarkModeTitle": "Dark Mode",
  "aboutFeatureDarkModeText": "Switch between light and dark themes to reduce eye strain and save battery on OLED devices.",
  
  "aboutHowToUseTitle": "How to Use",
  "aboutHowToCreateTitle": "Creating a Timer",
  "aboutHowToCreateText": "Click the 'Add Timer' button, enter a name, select timer mode (countdown or stopwatch), set duration (for countdown), and customize visual effects. Click 'Save' when done.",
  
  "aboutHowToControlTitle": "Controlling Timers",
  "aboutHowToControlText": "Use the control buttons to start, pause, stop, and reset your timers. You can also toggle fullscreen mode for better visibility.",
  
  "aboutHowToCustomizeTitle": "Customizing Effects",
  "aboutHowToCustomizeText": "While creating or editing a timer, select an effect type and adjust its appearance using the opacity, speed, and color controls.",
  
  "aboutHowToManageTitle": "Managing Timers",
  "aboutHowToManageText": "Edit existing timers by clicking the edit icon. Delete timers by clicking the delete icon twice. All your timers are saved automatically and will be available when you return.",
  
  "aboutProjectTitle": "About the Project",
  "aboutProjectText": "This project was developed as a modern web application using React, TypeScript, and various libraries for animations and state management.",
  
  "aboutVersionInfo": "Version 1.0.0"
}; 